import React from 'react'

type IconProps = React.SVGProps<SVGSVGElement>

export const Security24h = (props: IconProps) => (
  <svg
    {...props}
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M21 5V11C21 16.55 17.16 21.74 12 23C6.84 21.74 3 16.55 3 11V5L12 1L21 5ZM5 6.2998V12H12V20.9297C15.7199 19.7797 18.4699 16.1101 19 11.9902H12V3.19043L5 6.2998Z" fill="currentColor" />
  </svg>
)

export default Security24h